var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_svg__16/search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_svg__Vector",
    d: "M12 12L16 16M8.66667 13.3333C6.08934 13.3333 4 11.244 4 8.66667C4 6.08934 6.08934 4 8.66667 4C11.244 4 13.3333 6.08934 13.3333 8.66667C13.3333 11.244 11.244 13.3333 8.66667 13.3333Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
};
export default SvgSearch;